import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useNavigate } from 'react-router-dom';
import { Image, Container, VStack, Flex, Heading, Stack } from '@chakra-ui/react';

import { ContractCustomerScreen } from './contractCustomerScreen';
import { APPLY_CONTRACT_CUSTOMER } from '../../support/routeConstants';
import BtInput from '../../components/BtInput';
import { BtNavigate } from '../../components/BtNavigate';
import { ApplyScreen } from '../apply/applyScreen';

import BtLoading from '../../components/BtLoading';
import BtFailed from '../../components/BtFailed';
import BtButton from '../../components/BtButton';
import { images } from '../../support/imageSupport';
import BtHelmet from '../../components/BtHelmet';
import { LandingScreen } from '../landing/landingScreen';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

export const ContractCustomer: React.FC = () => {
  const viewModel = useAppSelector((state) => state.contractCustomer.viewModel);
  const logoUrl = useSelector((state: RootState) => state.gatInformation.logoUrl);
  const viewModelApply = useAppSelector((state) => state.apply.viewModel);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleOnChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    dispatch(await ContractCustomerScreen.updateState(viewModel, event));
  };

  const handleNext = async () => {
    dispatch(await ContractCustomerScreen.search(viewModel));
  };

  const handleNavigate = async (path: string) => {
    if (path.length === 0) {
      navigate(-1);
    } else {
      dispatch(await LandingScreen.reset(logoUrl));
      navigate(path);
    }
  };

  useEffect(() => {
    document.querySelector('body')?.setAttribute('id', 'body');
    if (ContractCustomerScreen.isNone(viewModel)) {
      dispatch(ContractCustomerScreen.start(viewModel));
    } else if (ContractCustomerScreen.isLoading(viewModel)) {
      (async () => {
        dispatch(await ContractCustomerScreen.load(viewModel));
      })();
    } else if (ContractCustomerScreen.isFinished(viewModel)) {
      navigate(APPLY_CONTRACT_CUSTOMER);
      dispatch(ApplyScreen.start(viewModelApply));
    }
  }, [viewModel]);

  if (ContractCustomerScreen.isLoading(viewModel)) {
    return <BtLoading {...viewModel.loading} />;
  } else if (ContractCustomerScreen.isReady(viewModel)) {
    return (
      <>
        <BtHelmet title={viewModel.metaTitle} />
        <Container padding={0} size='xl'>
          <BtNavigate {...viewModel.navigationTop} onClick={handleNavigate} />
          <Container padding={0} maxW='container.md'>
            <Flex pb={200}>
              <VStack w='full' h='full' p={10}>
                <Image pb={2} src={images(viewModel.image)} />
                <Heading pb={3} as='h1' variant='h1'>
                  {viewModel.greeting}
                </Heading>
                <Heading pb={7} as='h4' variant='h4' textAlign={'center'}>
                  {viewModel.body}
                </Heading>

                <Stack w='full' pt={5} spacing={[2, 8]} direction={['column', 'row']}>
                  <BtInput {...viewModel.govNo} onChange={handleOnChange} />
                </Stack>
                <Flex pb={4}></Flex>
                <BtButton
                  variant='primary'
                  size='lg'
                  w='full'
                  {...viewModel.next}
                  action={() => handleNext()}
                />
              </VStack>
            </Flex>
          </Container>
        </Container>
      </>
    );
  } else if (ContractCustomerScreen.isFailed(viewModel)) {
    return <BtFailed />;
  } else {
    return <BtLoading {...viewModel.loading} />;
  }
};
